'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('@slate-editor/utils');

var _LinkUtils = require('./LinkUtils');

var LinkKeyboardShortcut = function LinkKeyboardShortcut(event, change) {
  if (_utils.keyboardEvent.isMod(event) && event.key === 'k') return (0, _LinkUtils.insertLinkStrategy)(change);
  return;
};

exports.default = LinkKeyboardShortcut;